import multiOptions from '../options/multi';

const phase2Fields = {
  locations: {
    value: multiOptions,
    error: null,
    name: 'locations',
    placeholder: 'Select a Location',
    breed: 'multiselect',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  }
}

export const phase2QueryFields = {};

export default phase2Fields;



/** WEBPACK FOOTER **
 ** ./src/forms/campaign/createPhase2.js
 **/